// @ts-check
import React from 'react';

import Button from '@liquidweb-dev/undercurrent/Button';
import Dialog from '@liquidweb-dev/undercurrent/Dialog';
import DialogActions from '@liquidweb-dev/undercurrent/DialogActions';
import DialogContent from '@liquidweb-dev/undercurrent/DialogContent';
import DialogTitle from '@liquidweb-dev/undercurrent/DialogTitle';
import Typography from '@liquidweb-dev/undercurrent/Typography';

import useResolve from 'modules/queries/notification/useResolve';

/**
 * @typedef DismissAlertDialogProps
 * @property {number} notificationId
 * @property {() => void} onCloseClick
 */

/**
 * @param {DismissAlertDialogProps & import('@liquidweb-dev/undercurrent/Dialog').DialogProps} props
 */
const DismissAlertDialog = ({ notificationId, onCloseClick, ...rest }) => {
	const { mutate: resolve, isLoading } = useResolve();

	const handleSubmit = () =>
		resolve({ id: notificationId }, { onSuccess: onCloseClick });

	return (
		<Dialog onClose={onCloseClick} {...rest}>
			<DialogTitle onClose={onCloseClick}>Dismiss alert</DialogTitle>
			<DialogContent>
				<Typography variant="body-md">
					Are you sure you wish to dismiss this alert? You won&apos;t be able to
					access it again once dismissed.
				</Typography>
			</DialogContent>
			<DialogActions>
				<Button variant="ghost" onClick={onCloseClick} disabled={isLoading}>
					Cancel
				</Button>
				<Button color="danger" onClick={handleSubmit} loading={isLoading}>
					Confirm
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default DismissAlertDialog;
